import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Routes and Pages
 */
const ListBlogPage = React.lazy(() => import("./ListBlogPage"));
const AddBlogPage = React.lazy(() => import("./AddBlogPage.js"));
const EditBlogPage = React.lazy(() => import("./EditBlogPage"));

const BlogRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListBlogPage />} />
      <Route exact path="/add" element={<AddBlogPage />} />
      <Route exact path="/edit/:id" element={<EditBlogPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default BlogRoutes;
